import CreateTimeTrackingSidebar from "~/modules/timeTracking/components/CreateTimeTrackingSidebar";
import DeleteTimeTrackingModal from "~/modules/timeTracking/components/DeleteTimeTrackingModal";
import UpdateTimeTrackingSidebar from "~/modules/timeTracking/components/UpdateTimeTrackingSidebar";
import type { TimeTrackingController } from "~/modules/timeTracking/hooks/useTimeTrackingActions.ts";

type Props = {
	controller: TimeTrackingController;
	/** The dashboard calendar has its own create sidebar, with the absence form. */
	hideCreate?: boolean;
};

/** The create sidebar, the update sidebar and the delete dialog of a time tracking view. Mount it once for each view. */
export function TimeTrackingActions(props: Props) {
	const { controller, hideCreate } = props;
	const { queries } = controller;
	const locations = queries.locations.data ?? [];
	const quotas = queries.activeStaffingsAndQuotas.data?.quotas ?? {};
	const timeTrackingTypes = queries.timeTrackingTypes.data ?? [];
	const users = queries.users.data ?? [];
	const userDeliverables = queries.userDeliverables.data ?? [];
	const userLocations = queries.userLocations.data ?? [];
	const timeTrackingToUpdate = controller.timeTrackingToUpdate;

	return (
		<>
			{!hideCreate && <CreateTimeTrackingSidebar
				activeStaffings={controller.openActiveStaffings}
				nonProjectIsClosed={controller.nonProjectIsClosed}
				userDeliverables={userDeliverables}
				userLocations={userLocations}
				trackedStaffingIds={controller.trackedStaffingIdsOnSelectedDay}
				close={controller.closeCreate}
				isOpen={controller.selectedDate !== null}
				date={controller.selectedDate}
				locations={locations}
				quotas={quotas}
				selectedUserId={controller.userId}
				timeTrackingTypes={timeTrackingTypes}
				users={users}
				userIsFreelancer={controller.userIsFreelancer}
			/>}

			<UpdateTimeTrackingSidebar
				activeStaffings={controller.activeStaffings}
				userDeliverables={userDeliverables}
				userLocations={userLocations}
				close={controller.closeUpdate}
				isOpen={!!timeTrackingToUpdate}
				date={timeTrackingToUpdate?.date ? new Date(timeTrackingToUpdate.date) : null}
				locations={locations}
				quotas={quotas}
				trackedStaffingIds={controller.trackedStaffingIdsOnUpdateDay}
				timeTrackingData={timeTrackingToUpdate}
				selectedUserId={controller.userId}
				timeTrackingTypes={timeTrackingTypes}
				users={users} />

			<DeleteTimeTrackingModal
				isOpen={!!controller.timeTrackingToDelete}
				onClose={controller.closeDelete}
				timeTrackingData={controller.timeTrackingToDelete} />
		</>
	);
}
